/**
 *  @class
 *  @function CouponCode
 */
if (!customElements.get('coupon-code')) {
  class CouponCode extends HTMLElement {
    constructor() {
      super();
      this.onClipboardClick = this.onClipboardClick.bind(this);
    }

    connectedCallback() {
      this.clipboard = this.querySelector('.clipboard');
      this.text = this.clipboard ? this.clipboard.dataset.clipboardText : '';
      this.countdown = this.querySelector('.coupon-code--countdown');
      this.countdownTime = this.querySelector('.coupon-code--countdown-time');
      this.countdownTarget = this.dataset.countdownTarget ? new Date(this.dataset.countdownTarget).getTime() : null;

      if (this.clipboard) {
        this.clipboard.addEventListener('click', this.onClipboardClick);
      }

      this.startCountdown();
    }

    disconnectedCallback() {
      if (this.clipboard) {
        this.clipboard.removeEventListener('click', this.onClipboardClick);
      }

      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }

    onClipboardClick() {
      navigator.clipboard.writeText(this.text).then(() => {
        this.clipboard.classList.add('clipboard-success');
        setTimeout(() => {
          this.clipboard.classList.remove('clipboard-success');
        }, 1800);
      });
    }

    startCountdown() {
      if (!this.countdown || !this.countdownTime || !this.countdownTarget || Number.isNaN(this.countdownTarget)) {
        return;
      }

      const updateCountdown = () => {
        const now = Date.now();
        const distance = this.countdownTarget - now;

        if (distance <= 0) {
          this.countdown.hidden = true;
          clearInterval(this.countdownInterval);
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.countdownTime.textContent = `${String(days).padStart(2, '0')}D ${String(hours).padStart(2, '0')}H ${String(minutes).padStart(2, '0')}M ${String(seconds).padStart(2, '0')}S`;
        this.countdown.hidden = false;
      };

      updateCountdown();
      this.countdownInterval = setInterval(updateCountdown, 1000);
    }
  }
  customElements.define('coupon-code', CouponCode);
}
